<!-- eslint-disable -->
<template lang="pug">
    router-link.message-box(
        :to="routeObject"
    )
        img.message-box__avatar(v-if="!fromSupport", :src="chatImage")
        .message-box__info
            .message-box__name(
                :class="{'message-box__name--unread': lastMessage && lastMessage.unread}"
            )
                | {{ chatName }}
                span.message-box__name--light(v-if="fromSupport")
                    | &nbsp;({{ $i18n.t('support.support_departmentName_' + conversation.department.type) }})
            .message-box__date
                | {{ lastMessage.createdAt | humanizeDate("D MMMM") }}
            .message-box__text
                span.message-box__you(v-if="lastMessage.sender && lastMessage.sender.id === user.id")
                    | {{ $i18n.t('conversations.conversations_message_you') }}:&nbsp;
                span(v-html="lastMessage.body")
            a.message-box__file(v-if="lastMessage.attachments && lastMessage.attachments.length > 0")
                svg-icon.message-box__file-icon(name="paper", width="22px", height="22px")
                | {{ $i18n.t('conversations.conversations_message_attachedFile') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import humanize from '../../utils/humanize';

    export default {
        props: {
            conversation: {
                type: Object,
                default: {}
            },
            fromSupport: {
                type: Boolean,
                default: false
            }
        },
        mixins: [humanize],
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            routeObject () {
                let routeObject = {name: this.routeName};
                if (this.conversation.lastMessage) {
                    routeObject.params = {
                        id: this.conversation.id,
                    }
                } else {
                    routeObject.params = {
                        id: this.lastMessage.conversation.id,
                        messageId: this.lastMessage.id
                    }
                }
                return routeObject;
            },
            lastMessage () {
                return this.conversation.lastMessage
                        ? this.conversation.lastMessage
                        : this.conversation
            },
            chatImage () {
                return this.conversation.lastMessage
                        ? this.conversation.avatar
                        : this.conversation.sender.avatar;
            },
            chatName () {
                return this.conversation.lastMessage
                        ? this.conversation.name || this.conversation.theme
                        : this.conversation.sender.fullName;
            }
        },
        mounted () {
            this.routeName = this.fromSupport ? 'ticket' : 'conversation';
        },
        data () {
            return {
                routeName: ''
            }
        },
    }
</script>

<style lang="scss" scoped>
    .message-box {
        display: flex;
        box-sizing: border-box;
        padding: 30px 0;

        width: 100%;

        margin-left: 20px;

        color: $x-color-black;
    }

    .message-box__avatar {
        display: none;
        @include media($sm) {
            display: block;
            border-radius: 50%;
            margin-right: 30px;
            max-height: none;
            height: 80px;
            width: 80px;
            border: none;
        }
    }

    .message-box__name {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 10px;
    }

    .message-box__name--light {
        font-weight: normal;
    }

    .message-box__name--unread::after {
        content: "";
        margin: 4.5px 10px;
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: $hsl-color-blue-56;
        border-radius: $border-radius-circle;
    }

    .message-box__date {
        font-size: 14px;
        line-height: 17px;
        color: rgba(51, 51, 51, 0.6);
        margin-bottom: 10px;
    }

    .message-box__you {
        font-weight: 500;
    }

    .message-box__text {
        font-size: 16px;
        line-height: 24px;
        word-break: break-word;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;

        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        @include media($md) {
            -webkit-line-clamp: 1;
        }

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    .message-box__file {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
    }

    .message-box__file-icon {
        margin-right: 5px;
    }
</style>
